(() => {
  // app/scripts/merchandising-tool-drawer.js
  var MerchandisingDrawer = class extends HTMLElement {
    constructor() {
      super();
      this.closeBtn = this.querySelector(".js-close-drawer");
      this.overlay = document.querySelector(".js-overlay");
      this.init();
      this.bindEvents();
    }
    init() {
      this._openBtnHandler = (e) => {
        const btn = e.target.closest(".btn-merchandising");
        if (!btn)
          return;
        e.preventDefault();
        this.open(btn);
      };
      document.addEventListener("click", this._openBtnHandler);
    }
    open() {
      this.setAttribute("open", "");
      this.setAttribute("aria-hidden", "false");
      this.overlay.classList.add("is-visible");
    }
    close() {
      if (this.hasAttribute("open"))
        this.removeAttribute("open");
      this.setAttribute("aria-hidden", "true");
      this.overlay.classList.remove("is-visible");
    }
    bindEvents() {
      if (window.Shopify && Shopify.designMode) {
        this.sectionSelectHandler = this.handleSectionSelect.bind(this);
        this.sectionDeselectHandler = this.handleSectionDeselect.bind(this);
        document.addEventListener(
          "shopify:section:select",
          this.sectionSelectHandler
        );
        document.addEventListener(
          "shopify:section:deselect",
          this.sectionDeselectHandler
        );
      }
      if (this.closeBtn) {
        this._closeBtnHandler = (e) => {
          e.preventDefault();
          this.close(this.closeBtn);
        };
        this.closeBtn.addEventListener("click", this._closeBtnHandler);
      }
      this._overlayClickHandler = (e) => {
        if (e.target === this.overlay)
          this.close();
      };
      this.overlay.addEventListener("click", this._overlayClickHandler);
      this._escHandler = (e) => {
        if (e.key === "Escape" && this.hasAttribute("open"))
          this.close();
      };
      document.addEventListener("keydown", this._escHandler);
    }
    //Handle when the section is selected in the Theme Editor
    handleSectionSelect(evt) {
      if (evt.target === this.closest(".shopify-section"))
        this.open();
    }
    //Handle when the section is de-selected in the Theme Editor
    handleSectionDeselect(evt) {
      if (evt.target === this.closest(".shopify-section"))
        this.close();
    }
    disconnectedCallback() {
      document.removeEventListener("click", this._openBtnHandler);
      document.removeEventListener("keydown", this._escHandler);
      document.removeEventListener(
        "shopify:section:select",
        this.sectionSelectHandler
      );
      document.removeEventListener(
        "shopify:section:deselect",
        this.sectionDeselectHandler
      );
      document.removeEventListener("keydown", this._escHandler);
      this.overlay.removeEventListener("click", this._overlayClickHandler);
      this.closeBtn.removeEventListener("click", this._closeBtnHandler);
    }
  };
  if (!customElements.get("merchandising-drawer")) {
    customElements.define("merchandising-drawer", MerchandisingDrawer);
  }
})();
